import { useState } from "react";
import { DataService } from "../utils/dataService";
import { path } from "../config/enviroment";

const ONBOARDING_SOURCE = "onboardingcredibanco";

export type OnboardingStep = "radicate" | "merchant" | "affiliate";

export type OnboardingResult = {
  ok: boolean;
};

/**
 * Ejecuta, en orden y esperando cada respuesta, los tres servicios de
 * onboarding de Credibanco que deben terminar con éxito antes de abrir el
 * Checkout: radicación, generación de código único y afiliación.
 */
const useMarcaBlancaOnboarding = () => {
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState<OnboardingStep | null>(null);

  const callOnboardingStep = async (
    endpoint: string,
    clientId: string,
    branchId: string
  ): Promise<boolean> => {
    try {
      const _dataService = new DataService();
      const res = await _dataService.post(endpoint, {
        source: ONBOARDING_SOURCE,
        clientId,
        branchId,
        url: path,
      });
      return res?.data?.success === true;
    } catch {
      return false;
    }
  };

  const runOnboarding = async (
    clientId: string,
    branchId: string
  ): Promise<OnboardingResult> => {
    setLoading(true);
    try {
      setCurrentStep("radicate");
      const radicated = await callOnboardingStep(
        "/onboarding/radicate",
        clientId,
        branchId
      );
      if (!radicated) return { ok: false };

      setCurrentStep("merchant");
      const merchantCreated = await callOnboardingStep(
        "/onboarding/merchant",
        clientId,
        branchId
      );
      if (!merchantCreated) return { ok: false };

      setCurrentStep("affiliate");
      const affiliated = await callOnboardingStep(
        "/onboarding/affiliate",
        clientId,
        branchId
      );
      if (!affiliated) return { ok: false };

      return { ok: true };
    } finally {
      setLoading(false);
      setCurrentStep(null);
    }
  };

  return { runOnboarding, loading, currentStep };
};

export default useMarcaBlancaOnboarding;
